import ApiModel from './ApiModel'

class horo extends ApiModel {
}

export default new horo('/horo');